import {
  GET_SOLR_RESULT,
  UPDATE_SOLR_RESULT,
  TOGGLE_SOLR_FACET,
  SET_SOLR_TYPE_PARAMS,
  SET_SOLR_SEARCH,
} from '../../constants/ActionTypes';

export const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
  search: {
    query: {},
    facets: {},
    typeParams: {},
  },
};

export default function solr(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SOLR_RESULT}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_SOLR_RESULT}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action.result.result,
      };
    case `${GET_SOLR_RESULT}_FAIL`:
      return {
        ...state,
        error: 'failed',
        loaded: false,
        loading: false,
      };

    case `${UPDATE_SOLR_RESULT}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${UPDATE_SOLR_RESULT}_SUCCESS`:
      let newResultState = {
        ...state,
        error: null,
        loaded: true,
        loading: false,
      };

      newResultState.result.results[action.result.contentType][
        action.result.reviewState
      ] = action.result.results;

      return newResultState;
    case `${UPDATE_SOLR_RESULT}_FAIL`:
      return {
        ...state,
        error: 'failed',
        loaded: false,
        loading: false,
      };

    case `${SET_SOLR_SEARCH}`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: false,
        search: action.result.search,
      };

    case `${TOGGLE_SOLR_FACET}`:
      let facets = { ...state.search.facets };

      if (action.result.facetId in facets) {
        const index = facets[action.result.facetId].indexOf(
          action.result.facetValueId,
        );
        if (index === -1) {
          facets[action.result.facetId].push(action.result.facetValueId);
        } else {
          facets[action.result.facetId].splice(index, 1);
        }
      } else {
        facets[action.result.facetId] = [action.result.facetValueId];
      }

      return {
        ...state,
        error: null,
        loaded: false,
        loading: false,
        search: {
          ...state.search,
          facets,
        },
      };

    case `${SET_SOLR_TYPE_PARAMS}`:
      let newTypeParamsState = {
        ...state,
        error: null,
        loaded: false,
        loading: false,
      };

      if (
        !(action.result.contentType in newTypeParamsState.search.typeParams)
      ) {
        newTypeParamsState.search.typeParams[action.result.contentType] = {};
      }

      let params =
        newTypeParamsState.search.typeParams[action.result.contentType][
          action.result.reviewState
        ];

      // Set or Merge and Filter Params
      if (!params) {
        newTypeParamsState.search.typeParams[action.result.contentType][
          action.result.reviewState
        ] = action.result.params;
      } else {
        params = { ...params, ...action.result.params };
        Object.keys(params).forEach((key) => {
          if (!params[key]) {
            delete params[key];
          }
        });
        newTypeParamsState.search.typeParams[action.result.contentType][
          action.result.reviewState
        ] = params;
      }

      return newTypeParamsState;

    default:
      return state;
  }
}
